import React, { useEffect, useState } from "react";
import { Biscuit } from "../../../../utils";
import t from "../../../helpers/t";
import Dialog from "@material-ui/core/Dialog";
import _ from "lodash";
import { moment } from "../../../../../vendor";
import { userActions, matrixFieldsActions, useSelector } from "inbooma-api";

const ChangeMatrixField = (props) => {
  const {
    matrixField,
    setMatrixField,
    matrixFields,
    setMatrixFields,
    tempMatrixFields,
    tempIndex,
    setShowChange,
    dispatch,
    subpanel,
  } = props;
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const [localMatrixField, setLocalMatrixField] = useState(matrixField);
  const [extraUsers, setExtraUsers] = useState([]);
  const [initialized, setInitialized] = useState(false);
  const [userQueue, setUserQueue] = useState([]);
  const _user = useSelector((state) => state["users_data"].user);
  const _matrixField = useSelector((state) => state["matrix_fields_data"].editMatrixField);
  const [matrixFieldPending, setMatrixFieldPending] = useState(false);

  useEffect(() => {
    if (_matrixField.success === "" || !matrixFieldPending) {
      return;
    }
    setMatrixFieldPending(false);
  }, [_matrixField]);

  useEffect(() => {
    if (userQueue.length > 0 && !initialized) {
      let hasChanged = false;
      let clone = [...userQueue];

      for (let i = 0; i < clone.length; i++) {
        if (clone[i].status === "new") {
          clone[i].status = "pending";
          hasChanged = true;
          // fetch user
          props.dispatch(
            userActions.getUser({
              token: Biscuit.get("token"),
              id: clone[i].id,
              parameters: {
                headers: {
                  "Accept-Language": language,
                  "Content-Language": language,
                },
              },
            }),
          );
          break;
        } else if (clone[i].status === "pending") break;
      }

      if (hasChanged) setUserQueue(clone);
      setInitialized(true);
    }
  }, []);
  const userReady = () => {
    for (let i = 0; i < userQueue.length; i++) {
      if (userQueue[i].status === "new" || userQueue[i].status === "pending") return false;
    }
    return true;
  };

  useEffect(() => {
    if (_user.success === "") {
      // true or false no matter if a new task is created or an existing task modified
      return;
    }

    let clone;
    if (_user.success === true) {
      let known = false;
      for (let i = 0; i < extraUsers.length; i++) {
        if (extraUsers[i].id === _user.data.id) known = true;
      }
      if (!known) {
        clone = [...extraUsers];
        clone.push({ ..._user.data });
        setExtraUsers(clone);

        let clone2 = [...userQueue];
        for (let i = 0; i < clone2.length; i++) {
          if (clone2[i].status === "pending") {
            clone2[i].status = "success";
            break;
          }
        }
        setUserQueue(clone2);
      }
    } else {
      clone = [...userQueue];
      for (let i = 0; i < clone.length; i++) {
        if (clone[i].status === "pending") {
          clone[i].status = "failed";
          break;
        }
      }
      setUserQueue(clone);
    }
  }, [_user]);

  const getUserLabel = (user) => {
    let retVal = "";

    if (user.first_name === undefined) return retVal;

    if (user.first_name != null && user.first_name !== "") retVal += user.first_name;
    if (user.last_name != null && user.last_name !== "") {
      retVal !== "" ? (retVal += " " + user.last_name) : (retVal += user.last_name);
    }
    if (retVal === "" && user.username != null) {
      // no name found, take username
      retVal += user.username;
    }
    return retVal;
  };

  const _getUserNameById = (id, fetch = false) => {
    if (id === null || id === undefined) {
      return "";
    }

    // try also extra users
    for (let i = 0; i < extraUsers.length; i++) {
      if (extraUsers[i].id === id) {
        return getUserLabel(extraUsers[i]);
      }
    }

    if (fetch) {
      let clone = [...userQueue];
      for (let i = 0; i < userQueue.length; i++) {
        if (userQueue[i].id === id) {
          return "-";
        }
      }
      clone.push({ id: id, status: "new" });
      setUserQueue(clone);
    }

    return "-"; // user not listed
  };

  const onChange = (e) => {
    var clone = {};
    Object.assign(clone, localMatrixField);

    switch (e.target.name) {
      case "display_name":
        clone.display_name = e.target.value;
        break;
      case "allowed_domain":
        clone.allowed_domain = e.target.value;
        break;
      case "required":
        clone.required = e.target.checked;
        break;
      case "required_be":
        clone.required_be = e.target.checked;
        break;
      case "allow_foreign_domains":
        clone.allow_foreign_domains = e.target.checked;
        break;
    }
    setLocalMatrixField(clone);
  };

  const onSave = () => {
    let clone = {},
      clone2 = {},
      clone3 = {};

    Object.assign(clone3, localMatrixField);
    Object.assign(clone, matrixFields);
    Object.assign(clone2, tempMatrixFields);
    let ind = 0;
    /*  let clone4 = clone3;
        delete(clone4.modified);
        delete(clone4.modified_by);
        dispatch(matrixFieldsActions.editMatrixField({
            token:Biscuit.get('token'),
            matrix_field_id: clone4.id,
            data: clone4
        }));
        setMatrixFieldPending(true);*/
    if (tempIndex !== null) {
      clone2[tempIndex].map(function (value, key) {
        clone3[key] = value;
      });
      ind = tempIndex;
    }
    console.log("clone2", clone2);
    setMatrixField(clone3);
    clone2[ind] = clone3;
    setMatrixFields(clone2);
    close();
  };

  const close = () => {
    setShowChange(false);
  };

  const abortButtonRef = React.createRef();
  return (
    <>
      <Dialog
        onClose={close}
        aria-labelledby="changelogs-dialog-title"
        open={true}
        name="changeLogsDialog"
        id="changeLogsDialog"
        maxWidth={"md"}
      >
        <header className="inb-changelogs-header">
          <button
            type="submit"
            className={
              "button medium beautify beautify-" +
              Biscuit.get("user.client_id") +
              " button-submit round"
            }
            title={t("save")}
            onClick={onSave}
          >
            <>
              <i className="fi fi-check"> </i>
              <span>{t("save")}</span>
            </>
          </button>
          <button
            onClick={close}
            type="button"
            id="inb-changelogs-dialog-close-button"
            className="button hollow secondary right button-close-changelogs-dialog round"
            title={t("close matrixfield edit")}
          >
            <i className="fi fi-x"></i>
          </button>
        </header>
        <p className="off-canvas__subtitle off-canvas__header-region">
          {typeof localMatrixField.created !== "undefined" &&
            t("created_at") +
              " " +
              moment(localMatrixField.created).format("DD.MM.YYYY HH:mm:ss") +
              " " +
              t("edited_by") +
              " " +
              _getUserNameById(localMatrixField.created_by, false) +
              " | " +
              t("last_modified_at") +
              " " +
              moment(localMatrixField.modified).format("DD.MM.YYYY HH:mm:ss") +
              " " +
              t("edited_by") +
              " " +
              _getUserNameById(localMatrixField.modified_by, false)}
        </p>
        <div
          id="inb-c-main-matrixField"
          className="inb-c-listing off-canvas-content"
          data-off-canvas-content=""
        >
          <form className="off-content row">
            <div className="inb-form-group column medium-6 small-12 displayName">
              <label className="inb-form__controlLabel">{t("display_name")}</label>
              <div className="inb-form__controllClass">
                <input
                  id="display_name"
                  type="text"
                  className="form-control"
                  name="display_name"
                  required=""
                  autoComplete="false"
                  placeholder=""
                  value={localMatrixField.display_name}
                  onChange={onChange}
                  style={{ overflow: "hidden", resize: "none" }}
                />
              </div>
            </div>
            <div className="inb-form-group column medium-3 small-6 lang">
              <label className="inb-form__controlLabel">&nbsp;</label>
              <div className="inb-form__controllClass">
                <input
                  type="checkbox"
                  id="pt1"
                  className="form-control"
                  name="required"
                  autoComplete="false"
                  maxLength="255"
                  defaultChecked={localMatrixField.required}
                  onChange={onChange}
                  placeholder=""
                />
                <label htmlFor="pt1">{t("required", null, "capital")}</label>
              </div>
            </div>
            <div className="inb-form-group column medium-3 small-6 lang">
              <label className="inb-form__controlLabel">&nbsp;</label>
              <div className="inb-form__controllClass">
                <input
                  type="checkbox"
                  id="pt3"
                  className="form-control"
                  name="required_be"
                  autoComplete="false"
                  maxLength="255"
                  defaultChecked={localMatrixField.required_be}
                  onChange={onChange}
                  placeholder=""
                />
                <label htmlFor="pt1">{t("required_be", null, "capital")}</label>
              </div>
            </div>
            {localMatrixField.name === "email" && (
              <>
                <div className="inb-form-group column medium-6 small-12 username">
                  <label className="inb-form__controlLabel">{t("allowed_domain")}</label>
                  <div className="inb-form__controllClass">
                    <input
                      id="allowed_domain"
                      type="text"
                      className="form-control"
                      name="allowed_domain"
                      required=""
                      autoComplete="false"
                      placeholder=""
                      value={localMatrixField.allowed_domain}
                      onChange={onChange}
                      style={{ overflow: "hidden", resize: "none" }}
                    />
                  </div>
                </div>
                <div className="inb-form-group column medium-3 small-6 lang">
                  <label className="inb-form__controlLabel">&nbsp;</label>
                  <div className="inb-form__controllClass">
                    <input
                      type="checkbox"
                      id="pt2"
                      className="form-control"
                      name="allow_foreign_domains"
                      autoComplete="false"
                      maxLength="255"
                      defaultChecked={localMatrixField.allow_foreign_domains}
                      onChange={onChange}
                      placeholder=""
                    />
                    <label htmlFor="pt2">{t("allow_foreign_domains", null, "capital")}</label>
                  </div>
                </div>
              </>
            )}
          </form>
        </div>
      </Dialog>
    </>
  );
};

export default ChangeMatrixField;
